import React, { useEffect, useState } from "react";
import Input from "../../form/Input";
import Dropdown from "../../form/Dropdown";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import api from "../../../api";

export default function RegistrationForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    college: "",
    year: "",
    branch: "",
    language: "", // will be renamed to `course` when submitting
    password: "",
    confirmPassword: ""
  });


  useEffect(() => {
    const getApiData = async () => {
      try {
        const { data } = await api.get(
          `${process.env.REACT_APP_API_BASE_URL}colleges/approved`
        );
        setColleges(data);
      } catch (error) {
        toast.error("Failed to load colleges!");
      }
    };
    getApiData();
  }, []);

  const [loading, setLoading] = useState(false);
  const [colleges, setColleges] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validatePhone = (phone) =>
    /^[6-9]\d{9}$/.test(phone);

  const validatePassword = (password) => password.length >= 6;



  const handleSubmit = async (e) => {
    e.preventDefault();
    const {
      name,
      email,
      phone,
      college,
      year,
      branch,
      language,
      password,
      confirmPassword
    } = formData;

    // Validation
    if (!name || !email || !phone || !college || !year || !branch || !language || !password || !confirmPassword) {
      toast.error("All fields are required!");
      return;
    }

    if (name.trim().length < 3) {
      toast.error("Name must be at least 3 characters long!");
      return;
    }

    if (!validateEmail(email)) {
      toast.error("Please enter a valid email!");
      return;
    }

    if (!validatePhone(phone)) {
      toast.error("Enter a valid 10-digit phone number!");
      return;
    }

    if (!validatePassword(password)) {
      toast.error("Password must be at least 6 characters and include a letter and number.");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    try {
      setLoading(true);

      // Rename `language` to `course` to match backend
      const studentPayload = {
        name,
        email,
        phone,
        college,
        year,
        branch,
        course: language,
        password
      };

      const { data } = await api.post(
        `${process.env.REACT_APP_API_BASE_URL}students/register`,
        studentPayload
      );

      toast.success(data?.message || "Registration successful!");

      // Reset form
      setFormData({
        name: "",
        email: "",
        phone: "",
        college: "",
        year: "",
        branch: "",
        language: "",
        password: "",
        confirmPassword: ""
      });
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const getApiData = async () => {
      try {
        const { data } = await api.get(
          `${process.env.REACT_APP_API_BASE_URL}colleges/approved`
        );
        setColleges(data);
      } catch (error) {
        toast.error("Failed to load colleges!");
      }
    };
    getApiData();
  }, []);

  return (
    <>
      <form onSubmit={handleSubmit} className="flex flex-wrap">
        <Input
          md={6}
          id="name"
          name="name"
          placeholder="Enter your full name"
          value={formData.name}
          onChange={handleChange}
        />
        <Input
          md={6}
          id="email"
          name="email"
          type="email"
          placeholder="Enter your email"
          value={formData.email}
          onChange={handleChange}
        />
        <Input
          md={6}
          id="phone"
          name="phone"
          type="tel"
          placeholder="Enter phone number"
          value={formData.phone}
          onChange={handleChange}
        />

        <Dropdown
          md={6}
          id="college"
          name="college"
          label="College"
          value={formData.college}
          onChange={handleChange}
          options={colleges || []}
        />

        <Dropdown
          md={6}
          id="year"
          name="year"
          label="Year"
          value={formData.year}
          onChange={handleChange}
          options={[
            { _id: "2022", name: "2022" },
            { _id: "2023", name: "2023" },
            { _id: "2024", name: "2024" },
            { _id: "2025", name: "2025" }
          ]}
        />

        <Dropdown
          md={6}
          id="branch"
          name="branch"
          label="Branch"
          value={formData.branch}
          onChange={handleChange}
          options={[
            { _id: "IT", name: "IT" },
            { _id: "CS", name: "CS" },
            { _id: "Other", name: "Other" }
          ]}
        />

<Dropdown
  md={6}
  id="language"
  name="language"
  label="Course"
  value={formData.language}
  onChange={handleChange}
  options={[
    { _id: "Java Fullstack", name: "Java Fullstack" },
    { _id: "Python Fullstack", name: "Python Fullstack" },
    { _id: "MERN Stack", name: "MERN Stack" },
    { _id: "Web Designing", name: "Web Designing" },

    { _id: "UI/UX", name: "UI/UX" },
    { _id: ".NET Fullstack", name: ".NET Fullstack" },
    { _id: "PHP Fullstack", name: "PHP Fullstack" },
    { _id: "Software Testing", name: "Software Testing" },
    { _id: "Data Analysis", name: "Data Analysis" },
    { _id: "Data Scientist", name: "Data Scientist" },
    { _id: "C & C++", name: "C & C++" },
    { _id: "AWS", name: "AWS" },
    { _id: "DevOps with AWS", name: "DevOps with AWS" }
  ]}
/>


        <Input
          md={6}
          id="password"
          name="password"
          type="password"
          placeholder="Enter password (min 6 chars, letter & number)"
          value={formData.password}
          onChange={handleChange}
        />
        <Input
          md={6}
          id="confirmPassword"
          name="confirmPassword"
          type="password"
          placeholder="Confirm password"
          value={formData.confirmPassword}
          onChange={handleChange}
        />

        <button
          type="submit"
          disabled={loading}
          className={`w-full bg-indigo-600 text-white py-2 mt-4 rounded-md transition ${loading ? "opacity-50 cursor-not-allowed" : "hover:bg-indigo-700"
            }`}
        >
          {loading ? "Registering..." : "Register"}
        </button>
      </form>

      <p className="mt-5 text-center text-sm text-gray-500">
        Already Registered?{" "}
        <Link
          to="/login"
          className="font-semibold text-indigo-600 hover:text-indigo-500"
        >
          Login Here
        </Link>
      </p>
    </>
  );
}
